import { helpActions, helpTypes } from './index';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { applicationSelectors } from '../application';
import { languageSelectors } from '../language';

function* loadMeterReadingInstructions() {
    let applicationId: string = yield select(applicationSelectors.getApplicationId);
    try {
        const { data } = yield axios.get(`/api/public/meterReadingHelp/${applicationId}`);

        yield put(helpActions.loadMeterReadingInstructionsDone(data.instructions));
    } catch (e) {
        yield put(helpActions.loadMeterReadingInstructionsError());
    }
}

function* getGlobalHelpLanguagesSaga() {
    const applicationId: string = yield select(applicationSelectors.getApplicationId);
    try {
        const { status } = yield axios.get(`/api/public/help/${applicationId}`);
        const isEnabled = status === 200;
        yield put(helpActions.getGlobalHelpLanguagesDone(isEnabled));

        if (isEnabled) {
            const currentLanguage: string | undefined = yield select(languageSelectors.getCurrentLanguage);
            const enabledLanguages: { name: string }[] | undefined = yield select(languageSelectors.getEnabledLanguages);

            const langs = new Set<string>(enabledLanguages?.map((l) => l.name) ?? []);
            if (currentLanguage) langs.add(currentLanguage);

            yield all(
                Array.from(langs).map((lang) =>
                    call(function* () {
                        try {
                            const { data }: { data: { markdown?: string } } = yield axios.get(
                                `/api/public/help/${applicationId}/${lang}`,
                            );
                            if (data?.markdown) {
                                yield put(helpActions.setGlobalHelpContent(lang, data.markdown));
                            }
                        } catch (e) {
                            // best-effort, HelpScreen handles offline display
                        }
                    }),
                ),
            );
        }
    } catch (e) {
        yield put(helpActions.getGlobalHelpLanguagesError());
    }
}

export default function* helpSaga() {


    yield takeLatest(helpTypes.LOAD_METERREADING_INSTRUCTIONS, loadMeterReadingInstructions);
    yield takeLatest(helpTypes.GET_GLOBAL_HELP_LANGUAGES, getGlobalHelpLanguagesSaga);

    yield put(helpActions.loadMeterReadingInstructions());
    yield put(helpActions.getGlobalHelpLanguages());
}
